import { ENDPOINTS } from '../_config';

// #RP - Task  - Executive Commitee
export const getExecutiveCommiteePageData = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_EXECUTIVE_COMMITEE);
    if (request.status === 204) {
      // 204 => No content in backend
      return request;
    }
    return await request.json();
  } catch (e) {
    return null;
  }
};
